import { useEffect, useState } from 'react';

// Components
import { ButtonCustom, TextCustom, TextInputCustom } from '../../atoms';
import { DialogCustom } from '../../templates';
import { DialogActions, DialogContent } from '@mui/material';

// Hooks
import { useForm } from '../../../hooks/others';

//validaciones
import { typesValidation } from '../../../common/types';
import { validFormContacto, validInputEmail } from '../../../core/validations';

const DialogContacto = ({
  isOpenModal = false,
  setIsOpenModal = () => null,
  contacto = null,
  actionSubmit = () => null,
}) => {
  const [id, setId] = useState(null);
  const [correo, setCorreo] = useState('');
  const [telefono, setTelefono] = useState('');

  //validaciones
  const [formErrors, setFormErrors, reset] = useForm({
    correo: '',
    telefono: '',
  });
  const [formSuccess, setFormSuccess] = useForm({
    correo: false,
    telefono: false,
  });

  useEffect(() => {
    if (isOpenModal) {
      if (contacto) {
        setId(contacto?.id);
        setCorreo(contacto?.correo);
        setTelefono(contacto?.telefono);
      } else {
        resetValues();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal]);

  const handleSubmit = () => {
    if (handleValidForm()) {
      let params;

      if (id) {
        //* mandar la informacion al endpoint
        params = {
          id,
          correo,
          telefono,
        };
      } else {
        //* mandar la informacion al endpoint
        params = {
          correo,
          telefono,
        };
      }
      actionSubmit(params);
    }
  };

  //* funcion de validacion del formulario
  const handleValidForm = () => {
    const params = { correo, telefono };
    const responseValid = validFormContacto(params);
    const { isValid, msgValid } = responseValid;
    setFormErrors(msgValid.errors);
    setFormSuccess(msgValid.success);
    return isValid;
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  const resetValues = () => {
    reset();
    setId(null);
    setCorreo('');
    setTelefono('');
  };

  const formatData = (e, value) => {
    const valorInput = e.target.value;

    if (formErrors[value] && valorInput) {
      if (
        value === 'correo' &&
        !validInputEmail(valorInput, typesValidation.validateEmail)
      ) {
        setFormErrors({
          ...formErrors,
          [value]: 'Formato de correo electrónico no válido.',
        });
      } else {
        setFormErrors({ ...formErrors, [value]: '' });
      }
    }
  };

  const formatTel = e => {
    const filteredValue = e.target.value.replace(/[^0-9]/g, '');

    const value = filteredValue;
    const regex = /^(\d{0,4})(\d{0,4})$/;
    const formattedValue = value.replace(regex, function (match, p1, p2) {
      if (p2.length > 0) {
        return `${p1}-${p2}`;
      } else {
        return p1;
      }
    });

    e.target.value = formattedValue;
    setTelefono(e.target.value);
  };

  return (
    <DialogCustom
      open={isOpenModal}
      setOpen={handleCloseModal}
      title={'Editar Contacto'}
      disabledDismiss
    >
      <DialogContent style={{ width: 600 }}>
        <div className="grid gap-x-10 mt-10 px-7 ">
          <div className="mt-5 mb-5">
            <TextCustom text="Correo Electrónico" required />
            <TextInputCustom
              placeholder="Escribe correo electrónico"
              borderStyle={true}
              value={correo}
              setValue={setCorreo}
              className="mb-2"
              msgError={formErrors.correo}
              success={formSuccess.correo}
              type="email"
              onKeyUp={event => formatData(event, 'correo')}
            />
          </div>
          <div className="mt-5 mb-5">
            <TextCustom text="Teléfono" required />
            <TextInputCustom
              placeholder="Escribe número de teléfono"
              borderStyle={true}
              value={telefono}
              setValue={setTelefono}
              className="mb-2"
              msgError={formErrors.telefono}
              success={formSuccess.telefono}
              onKeyUp={event => formatTel(event, this)}
              maxLength={9}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="mx-auto mt-10">
          <ButtonCustom
            text={`Guardar cambios `}
            typeColor="general"
            width={'200px'}
            onClick={handleSubmit}
          />
        </div>
      </DialogActions>
    </DialogCustom>
  );
};

export default DialogContacto;
